import React from "react";
import PortalLogoutButton, {
  PortalLogoutButtonProps,
} from "../PortalLogoutButton/PortalLogoutButton";
import { useAssociationLogout } from "../../hooks/useAssociationLogout";

/** The association persona's logout control: the shared button over `useAssociationLogout`. */
const AssociationLogoutButton: React.FC<
  Omit<PortalLogoutButtonProps, "control">
> = (props) => {
  const control = useAssociationLogout();
  return <PortalLogoutButton control={control} {...props} />;
};

export default AssociationLogoutButton;
